export const FeatureFlagDeclarations = {
  enableCookielessLookerEmbed: {
    key: 'enable-cookieless-looker-embed',
    defaultValue: false,
  },
  newTermsAndAgreements: {
    key: 'new-country-terms-and-conditions',
    defaultValue: {
      enabled: false,
      mustAcceptByDateUTC: '2021-04-26T00:00:00.000Z',
      newTermsLabel: 'canada_mar_2021',
    },
  },
  enableAddOnCentral: {
    key: 'enable-add-on-central',
    defaultValue: true,
  },
  enableSelfMigration: {
    key: 'enable-self-migration',
    defaultValue: false,
  },
  enableTransferOrders: {
    key: 'enable-stock-transfer',
    defaultValue: true,
  },
  enableCheapestRate: {
    key: 'enable-cheapest-rate',
    defaultValue: false,
  },
  enableDeliveryOptionsDetails: {
    key: 'enable-delivery-options-details',
    defaultValue: true,
  },
  enableApiSettingsRestrictions: {
    key: 'enable-api-settings-restrictions',
    default: false,
  },
  enableDeliveryOptionsForSellerLocation: {
    key: 'enable-delivery-options-for-seller-location',
    defaultValue: false,
  },
  enableManualStoreDeliveryOptions: {
    key: 'enable-manual-store-delivery-options',
    defaultValue: false,
  },
  enableNewFulfillmentPlanActivity: {
    key: 'enable-new-fulfillment-plan-activity',
    defaultValue: false,
  },
  enableBrandedSMS: {
    key: 'enable-branded-sms',
    defaultValue: false,
  },
  enableThirdPartyDelivery: {
    key: 'enable-third-party-delivery',
    defaultValue: false,
  },
  enableV3CustomsWeightField: {
    key: 'enable-v3-customs-weight-and-sku-field',
    defaultValue: false,
  },
  enableCpscCertificateFields: {
    key: 'enable-cpsc-certificate-fields',
    defaultValue: false,
  },
  enableCarrierPackageDimensionLock: {
    key: 'enable-carrier-package-dimension-lock',
    defaultValue: false,
  },
  enableExternalInventory: {
    key: 'enable-external-inventory',
    defaultValue: true,
  },
  // Per-country DDP feature flags
  enablePrepaidDutiesAndTaxUs: {
    key: 'enable-prepaid-duties-and-tax-us',
    defaultValue: true,
  },
  enablePrepaidDutiesAndTaxCa: {
    key: 'enable-prepaid-duties-and-tax-ca',
    defaultValue: false,
  },
  enablePrepaidDutiesAndTaxGb: {
    key: 'enable-prepaid-duties-and-tax-gb',
    defaultValue: false,
  },
  enableRateShopperFreemium: {
    key: 'enable-rate-shopper-freemium',
    defaultValue: false,
  },
  maximumServiceCollectionCount: {
    key: 'maximum-service-collection-count',
    defaultValue: 99,
  },
  enableAmazonShipNotifyUpdates: {
    key: 'enable-amazon-ship-notify-updates',
    defaultValue: false,
  },
  enableLocalDeliveryDriverTip: {
    key: 'enable-local-delivery-driver-tip',
    defaultValue: false,
  },
  enableBalanceHistory: {
    key: 'enable-balance-history',
    defaultValue: false,
  },
  enableBundledProducts: {
    key: 'enable-bundled-products',
    defaultValue: false,
  },
  primaryPusherApp: {
    key: 'primary-pusher-app',
    defaultValue: window.SS_GLOBALS.frontEndConfig.pusherKey,
  },
  enableInteractiveReloadButtonOnOrdersGrid: {
    key: 'enable-interactive-reload-button-on-orders-grid',
    defaultValue: false,
  },
  enableCswRatePayloadDiff: {
    key: 'enable-csw-rate-payload-diff',
    defaultValue: false,
  },
  enableDelegationDate: {
    key: 'enable-delegation-date',
    defaultValue: false,
  },
  overwriteCustomerOverviewDebounce: {
    key: 'overwrite-customer-summary-debounce',
    defaultValue: 250,
  },
  enablePudoDeliveryOptions: {
    key: 'enable-pudo-delivery-options',
    defaultValue: false,
  },
  enableV3Coachmarks: {
    key: 'enable-v3-coachmarks',
    defaultValue: true,
  },
  newInsuranceSettingsEnabled: {
    key: 'new-insurance-settings-enabled',
    defaultValue: false,
  },
  enableConsolidatedBundleData: {
    key: 'enable-bundle-instock-data',
  },
  enableV3ContainerLabelShipments: {
    key: 'enable-container-label-shipments',
    defaultValue: true,
  },
  enableOnboardVariantStoreSetup: {
    key: 'enable-onboard-variant-store-setup',
    defaultValue: false,
  },
  enableExtendedFulfillmentsGridSortFilter: {
    key: 'enable-extended-fulfillments-grid-sort-filter',
    defaultValue: false,
  },
  enableShippingSuppliesLink: {
    key: 'enable-shipping-supplies-link',
    defaultValue: true,
  },
  enableOrderOverview: {
    key: 'enable-order-overview',
    defaultValue: false,
  },
  enableWalletRegistrationErrorNotification: {
    key: 'enable-wallet-registration-error-notification',
    defaultValue: false,
  },
  enablePortionedEODManifest: {
    key: 'enable-portioned-eod-manifest',
    defaultValue: false,
  },
  enableSideBySideRateBrowser: {
    key: 'enable-side-by-side-rate-browser',
    defaultValue: false,
  },
  enableLiveRatesWithDimensions: {
    key: 'enable-live-rates-with-dimensions',
    defaultValue: false,
  },
  rateBrowserDefaultView: {
    key: 'rate-browser-default-view',
    defaultValue: 'carriers',
  },
  enableFulfillmentRates: {
    key: 'enable-fulfillment-rates',
    defaultValue: false,
  },
  enableRateBrowserFixup: {
    key: 'enable-rate-browser-fixup',
    defaultValue: true,
  },
  enableCreateLabelBatchesNavRefreshBypass: {
    key: 'enable-create-label-batches-nav-refresh-bypass',
    defaultValue: true,
  },
  enableMarketplaceSecondaryActionRework: {
    key: 'enable-marketplace-secondary-action-rework',
    defaultValue: true,
  },
  enableRemoveIframeMarketplace: {
    key: 'enable-remove-iframe-marketplace',
    defaultValue: false,
  },
  enableDirectCuiIntegrations: {
    key: 'enable-direct-cui-integrations',
    defaultValue: false,
  },
  enableNewProductImport: {
    key: 'enable-new-product-import',
    defaultValue: true,
  },
  enableAddressValidator: {
    key: 'enable-address-validator',
    defaultValue: false,
  },
  enableAsyncReportGeneration: {
    key: 'enable-async-report-generation',
    defaultValue: true,
  },
  connectClientVersion: {
    key: 'connect-client-version',
  },
  enableSetupFlow: {
    key: 'enable-setup-flow',
  },
  enableDeliveryOptionsCanadianShopify: {
    key: 'enable-delivery-options-ca-shopify',
    defaultValue: true,
  },
  enableDeliveryOptionsCanadianBigCommerce: {
    key: 'enable-delivery-options-ca-bigcommerce',
    defaultValue: true,
  },
  enableGrow493Experiment: {
    key: 'grow-493-orders-grid-empty-state-routing-change',
    defaultValue: 'go-to-onboarding',
  },
  enableSenderEmails: {
    key: 'enable-sender-emails',
    defaultValue: true,
  },
  enableAddOnCarousel: {
    key: 'enable-add-on-carousel',
    defaultValue: true,
  },
  enable3plDashboard: {
    key: 'enable-3pl-dashboard',
    defaultValue: false,
  },
  enableHomePage: {
    key: 'enable-home-page',
    defaultValue: false,
  },
  enableHomePage2: {
    key: 'enable-home-page2',
    defaultValue: false,
  },
  gettingStartedGuideEnabled: {
    key: 'getting-started-guide',
    defaultValue: false,
  },
  enableDeliverByDate: {
    key: 'enable-deliver-by-date',
    defaultValue: true,
  },
  enablePremiumProgramTags: {
    key: 'enable-premium-program-tags',
    defaultValue: true,
  },
  enableCommittedInventoryCount: {
    key: 'enable-committed-inventory-count',
    defaultValue: true,
  },
  enableSyncInventoryOnOrderImport: {
    key: 'sync-inventory-on-order-import',
    defaultValue: true,
  },
  enableInventorySyncPercentage: {
    key: 'enable-inventory-sync-stock-percentage-option',
    defaultValue: true,
  },
  enableInventorySyncRefresh: {
    key: 'enable-inventory-sync-refresh',
    defaultValue: false,
  },
  enableProductInventorySyncTab: {
    key: 'enable-product-inventory-sync-tab',
    defaultValue: false,
  },
  enableShopPromiseTag: {
    key: 'enable-shop-promise-tag',
    defaultValue: false,
  },
  enableNewOrderImport: {
    key: 'enable-new-order-import',
    defaultValue: false,
  },
  enableFedexRateComparison: {
    key: 'enable-fedex-rate-comparison',
  },
  enableFedexWalletServiceMappings: {
    key: 'enable-fedex-wallet-service-mappings',
    defaultValue: true,
  },
  enableRateRecommendationsForFedexServices: {
    key: 'enable-rate-recommendations-for-fedex-services',
    defaultValue: { ServiceIds: [] },
  },
  enableRateRecommendationsForServices: {
    key: 'enable-rate-recommendations-for-services',
    defaultValue: {
      ServiceIds: [],
    },
  },
  enableUpsWwexInRateRecommendations: {
    key: 'enable-ups-wwex-in-rate-recommendations',
    defaultValue: false,
  },
  enableUpsInvoicedInRateRecommendations: {
    key: 'enable-ups-invoiced-by-shipstation-in-rate-recommendations',
    defaultValue: false,
  },
  enableUspsRateComparison: {
    key: 'enable-usps-rate-comparison',
    defaultValue: true,
  },
  enableAsyncMarketplaceNotifications: {
    key: 'enable-async-marketplace-notifications',
    defaultValue: true,
  },
  enableAsyncSendNotifications: {
    key: 'enable-async-send-notifications',
    defaultValue: true,
  },
  enablePrinterFiltering: {
    key: 'enable-printer-filtering',
    defaultValue: false,
  },
  enableDangerousGoods: {
    key: 'enable-dangerous-goods',
    defaultValue: false,
  },
  enableUnitsOfMeasure: {
    key: 'enable-units-of-measure',
    defaultValue: false,
  },
  enableLotTracking: {
    key: 'enable-lot-tracking',
    defaultValue: false,
  },
  enablePurchaseOrders: {
    key: 'enable-purchase-orders',
    defaultValue: true,
  },
  enableCompareRateOnLoad: {
    key: 'enable-compare-rate-on-load',
    defaultValue: {
      compareRate: false,
      debounceMs: 0,
    },
  },
  enableGettingStartedGuideForExperiment: {
    key: 'enable-getting-started-guide-for-experiment',
    defaultValue: false,
  },
  cutOffDateForHidingNonWalletInsurance: {
    key: 'cut-off-date-for-hiding-non-wallet-insurance',
    defaultValue: '',
  },
  enableSwitchAndSaveRateRecommendations: {
    key: 'enable-switch-and-save-rate-recommendations',
    defaultValue: true,
  },
  enableAlternativeRatesRateShopperRecommendations: {
    key: 'enable-alternative-rates-rate-shopper-recommendations',
    defaultValue: false,
  },
  enhanceGlobalEShippingConfiguration: {
    key: 'enhance-global-e-shipping-configuration',
    defaultValue: true,
  },
  shouldSendV3QueueServiceDownloadUrl: {
    key: 'should-send-v3-queue-service-download-url',
    defaultValue: true,
  },
  enableByoAbTesting: {
    key: 'enable-byo-ab-test',
    defaultValue: false,
  },
  enableRateShopperDeliverByDate: {
    key: 'enable-rate-shopper-deliver-by-date',
  },
  enableBulkRecommendedRatesOnSuperSelect: {
    key: 'enable-bulk-recommended-rates-on-super-select',
    defaultValue: true,
  },
  enableBulkRatesOnSuperSelect: {
    key: 'enable-bulk-rates-on-super-select',
    defaultValue: true,
  },
  hideStampsConnection: {
    key: 'hide-stamps-connection',
    defaultValue: true,
  },
  enableAdyenSubscriptionPaymentMethod: {
    key: 'enable-adyen-for-subscription-payment-method',
    defaultValue: false,
  },
  enableScanInitialWeightRead: {
    key: 'enable-scan-initial-weight-read',
    defaultValue: true,
  },
  enableSecurityPage: {
    key: 'enable-security-page',
    defaultValue: true,
  },
  enableSmartfillABTest: {
    key: 'smartfill-ab-test',
    defaultValue: false,
  },
  enableCostReviewModalRefactor: {
    key: 'enable-cost-review-modal-refactor',
    defaultValue: true,
  },
  enableNewLayoutOptions: {
    key: 'enable-new-layout-options',
    defaultValue: true,
  },
  enableMultiPackageShipmentsOrderDetails: {
    key: 'multi-package-shipments-order-details',
    defaultValue: true,
  },
  enableMultiPackageShipments: {
    key: 'multi-package-shipments',
    defaultValue: true,
  },
  enablePickPackAccess: {
    key: 'enable-pick-pack-access',
    defaultValue: false,
  },
  enableStopPicking: {
    key: 'enable-stop-picking',
    defaultValue: false,
  },
  enablePickBatchOrderGrid: {
    key: 'enable-pick-batch-order-grid',
    defaultValue: false,
  },
  enableShipFromSearchableDropdown: {
    key: 'enable-ship-from-searchable-dropdown',
    defaultValue: true,
  },
  enableAuctanePayIdv: {
    key: 'enable-plaid-idv',
    defaultValue: true,
  },
  enable2025Q2PlanFeatureGates: {
    key: 'enable-2025-q2-plan-feature-gates',
    defaultValue: true,
  },
  enableShippingServiceSearchableDropdown: {
    key: 'enable-shipping-service-searchable-dropdown',
    defaultValue: true,
  },
  enableAutomationRecommendations: {
    key: 'enable-automation-recommendations',
    defaultValue: false,
  },
  enableReorderAssist: {
    key: 'enable-reorder-assist',
    defaultValue: true,
  },
  enableInboundInventory: {
    key: 'inbound-inventory',
    defaultValue: false,
  },
  enableLotTrackingBillingPlan: {
    key: 'enable-lot-tracking-billing-plan',
    defaultValue: true,
  },
  enablePickToTote: {
    key: 'enable-pick-to-tote',
    defaultValue: true,
  },
  enableSurchargeUI: {
    key: 'enable-surcharge-ui',
    defaultValue: true,
  },
  enableBillingReport: {
    key: 'enable-billing-report',
    defaultValue: true,
  },
  enableDutiesInAmountSummary: {
    key: 'enable-duties-in-amount-summary',
    defaultValue: true,
  },
  enableLabsSettingsPage: {
    key: 'enable-labs-settings-page',
    defaultValue: true,
  },
  enableInventoryLocationsBarcode: {
    key: 'enable-inventory-locations-barcode',
    defaultValue: true,
  },
  enableSsrActivationNoAuth: {
    key: 'enable-ssr-activation-no-auth',
    defaultValue: true,
  },
  enableInventoryLocationCsvImport: {
    key: 'enable-inventory-location-csv-import',
    defaultValue: true,
  },
  enableWalletedFedexNotification: {
    key: 'enable-walleted-fedex-notification',
    defaultValue: false,
  },
  enableAddToPickingQueue: {
    key: 'enable-add-to-picking-queue',
    defaultValue: true,
  },
  enablePickingExceptions: {
    key: 'enable-picking-exceptions',
    defaultValue: true,
  },
  isRefundAssistVisible: {
    key: 'refund-assist-is-visible',
    defaultValue: false,
  },
  enableSendPurchaseOrderEmails: {
    key: 'enable-send-purchase-order-emails',
    defaultValue: false,
  },
  enableUspsCopNsaInstruction: {
    key: 'enable-usps-cop-nsa-instruction', // this is the feature flag that allows the sellerId to be used instead of the couponCode
    defaultValue: false,
  },
  enableUspsCopAccountSetup: {
    key: 'enable-usps-cop-account-setup', // this is the global feature flag on/off switch
    defaultValue: true,
  },
  enablePickPackSettingsMobileConfiguration: {
    key: 'enable-pick-pack-settings-mobile-configuration',
    defaultValue: true,
  },
  enableMobilePickingShowLocationStep: {
    key: 'enable-mobile-picking-show-location-step',
    defaultValue: false,
  },
  enableMobilePickingManualItemConfirmation: {
    key: 'enable-mobile-picking-manual-item-confirmation',
    defaultValue: false,
  },
  enableWalletTermsModal: {
    key: 'enable-wallet-terms-modal',
    defaultValue: false,
  },
  enableFulfillmentsReturns: {
    key: 'enable-fulfillments-returns',
    defaultValue: false,
  },
  enableEnhancedReturnsErrors: {
    key: 'enable-enhanced-returns-errors',
    defaultValue: true,
  },
  enableHsCodesFetchingForAll: {
    key: 'enable-hs-codes-fetching-for-all',
    defaultValue: true,
  },
  enableHsCodePreFilled: {
    key: 'enable-hs-code-pre-filled',
    defaultValue: false,
  },
  enableDynamicPricing: {
    key: 'enable-dynamic-pricing',
    defaultValue: false,
  },
  enableBatchScanning: {
    key: 'enable-batch-scanning',
    defaultValue: true,
  },
  enableCreateOrderFromAsn: {
    key: 'enable-create-order-from-asn',
    defaultValue: true,
  },
  enableAIAutomationRule: {
    key: 'enable-generate-automation-rule-with-ai',
    defaultValue: true,
  },
  enableLossPrevention: {
    key: 'enable-loss-prevention',
    defaultValue: false,
  },
  enableShipStationAnalyticsOverride: {
    key: 'enable-shipstation-analytics-overrride',
    defaultValue: false,
  },
  enableAiShippyAssistant: {
    key: 'enable-ai-shippy-assistant',
    defaultValue: true,
  },
  enableShippyExternalSupport: {
    key: 'enable-shippy-external-support',
    defaultValue: false,
  },

  switchFulfillmentDashboardToRawEndpoint: {
    key: 'switch-fulfillment-dashboard-to-raw-endpoint',
    defaultValue: false,
  },
  enableAiHarmonizationCodeGenerator: {
    key: 'enable-ai-harmonization-code-generator',
    defaultValue: true,
  },
  enableFbsZoneComparisonSection: {
    key: 'enable-fbs-zone-comparison-section',
    defaultValue: true,
  },
  enableSellerPhoneUpdate: {
    key: 'enable-seller-phone-update',
    defaultValue: true,
  },
  enableScanToVerifyInOrderDetails: {
    key: 'enable-scan-to-verify-in-order-details',
    defaultValue: true,
  },
  enableProductItemWeightAndDimensions: {
    key: 'enable-product-item-weight-and-dimensions',
    defaultValue: false,
  },
  enablePackingRecommendation: {
    key: 'enable-packing-recommendation',
    defaultValue: false,
  },
  enablePackingRecommendationFtuWizard: {
    key: 'enable-packing-recommendation-ftu-wizard',
    defaultValue: false,
  },
  enableShippingServiceSearchableDropdownInRateBrowser: {
    key: 'enable-shipping-service-searchable-dropdown-in-rate-browser',
    defaultValue: false,
  },
  enableShippingServiceSearchableDropdownInSidebar: {
    key: 'enable-shipping-service-searchable-dropdown-in-sidebar',
    defaultValue: false,
  },
  zoomableWorkflowDrawer: {
    key: 'zoomable-workflow-drawer',
    defaultValue: false,
  },
  enable24HourShopifyProductSync: {
    key: 'enable-24-hour-shopify-product-sync',
    defaultValue: true,
  },
  enableShippingOptionsForRateShoppers: {
    key: 'enable-shipping-options-for-rate-shoppers',
    defaultValue: false,
  },
  enableShippingOptionsForDefaultRateShoppers: {
    key: 'enable-shipping-options-for-default-rate-shoppers',
    defaultValue: true,
  },
  enableSingleLabelSellerExperiment: {
    key: 'enable-single-label-seller-experiment',
    defaultValue: true,
  },
  enableCm6PackingSlipEditor: {
    key: 'enable-cm6-packing-slip-editor',
    defaultValue: true,
  },
  enableNewHtmlEditorForPackingSlips: {
    key: 'enable-new-html-editor-for-packing-slips',
    defaultValue: false,
  },
  enableHtmlEditorForEmailTemplates: {
    key: 'enable-html-editor-for-email-templates',
    defaultValue: false,
  },
  enableHtmlEditorChatAssistant: {
    key: 'enable-html-editor-chat-assistant',
    defaultValue: false,
  },
  enablePickListHtmlEditor: {
    key: 'enable-pick-list-html-editor',
    defaultValue: false,
  },
  enablePickListTemplateSelection: {
    key: 'enable-pick-list-template-selection',
    defaultValue: false,
  },
  enableTemplateLibrary: {
    key: 'enable-template-library',
    defaultValue: false,
  },
  enableQrCodesInHtmlPackingSlips: {
    key: 'enable-qr-codes-in-html-packing-slips',
    defaultValue: false,
  },
  enablePurchaseOrderCsvImport: {
    key: 'enable-purchase-order-csv-import',
    defaultValue: true,
  },
  enablePurchaseOrderBarcode: {
    key: 'enable-purchase-order-barcode',
    defaultValue: false,
  },
  enableSingleFulfillmentPlanOrdersGridSidebarDrawerRedesign: {
    key: 'enable-single-fulfillment-plan-orders-sidebar-redesign',
    defaultValue: false,
  },
  enableUpsTerms2: {
    key: 'enable-ups-terms-2',
    defaultValue: false,
  },
  enableSuppliersGrid: {
    key: 'enable-suppliers-grid',
    defaultValue: false,
  },
  enableSupplyPage: {
    key: 'enable-supply-page',
    defaultValue: false,
  },
  enableSaveShippingConfigServiceCollectionSync: {
    key: 'enable-save-shipping-config-service-collection-sync',
    defaultValue: true,
  },
  enableBackgroundImport: {
    key: 'enable-background-import',
    defaultValue: false,
  },
  enableProductDetailsDrawerV3: {
    key: 'enable-product-details-drawer-v3',
    defaultValue: false,
  },
  enableInsurancePromoExperiment: {
    key: 'enable-insurance-promo',
    defaultValue: false,
  },
  enableInsurancePromoExtended: {
    key: 'enable-insurance-promo-extended',
    defaultValue: true,
  },
  enableInsurancePromoStandalone: {
    key: 'enable-insurance-promo-standalone',
    defaultValue: false,
  },
  enableReturnInsuranceSettings: {
    key: 'return-insurance-settings',
    defaultValue: false,
  },
  enableNotificationHub: {
    key: 'enable-notification-hub',
    defaultValue: false,
  },
  enablePlanFeaturesTrialUpsell: {
    key: 'enable-plan-features-trial-upsell',
    defaultValue: false,
  },
  enableUpgradePlanPromotionalBanner: {
    key: 'enable-upgrade-plan-promotional-banner',
  },
  enableAnalyticsRoleSelfService: {
    key: 'enable-analytics-role-self-service',
    defaultValue: true,
  },
  enablePhoneNumberCapture: {
    key: 'enable-phone-number-capture',
    defaultValue: false,
  },
  enableConversationalAnalytics: {
    key: 'enable-conversational-analytics',
    defaultValue: false,
  },
  enableStoreCurrencyForCustomsForm: {
    key: 'enable-store-currency-for-customs-form',
    defaultValue: false,
  },
  enableWooCommerceCheckoutRates: {
    key: 'enable-woocommerce-checkout-rates',
    defaultValue: false,
  },
  enableOperationsCards: {
    key: 'enable-operations-cards',
    defaultValue: false,
  },
  enableExpandedTaxIdCountries: {
    key: 'enable-expanded-tax-id-countries',
    defaultValue: false,
  },
  enableStockAudit: {
    key: 'enable-stock-audit',
    defaultValue: false,
  },
  isDocumentUploadEnabled: {
    key: 'is-document-upload-enabled',
    defaultValue: false,
  },
  enableCustomsTabView: {
    key: 'enable-customs-tab-view',
    defaultValue: false,
  },
  enableFreightSupport: {
    key: 'enable-freight-support',
    defaultValue: false,
  },
  enableFreightInvoiceSupport: {
    key: 'enable-freight-invoice-support',
    defaultValue: false,
  },
  enableLtlFreight: {
    key: 'enable-ltl-freight',
    defaultValue: false,
  },
  enableLtlRegistration: {
    key: 'enable-ltl-registration',
    defaultValue: false,
  },
  enableLtlHazmat: {
    key: 'enable-ltl-hazmat',
    defaultValue: false,
  },
  enableLtlAutomationRules: {
    key: 'enable-ltl-automation-rules',
    defaultValue: false,
  },
  enableLtlNotifications: {
    key: 'enable-ltl-notifications',
    defaultValue: false,
  },
  enableLtlWizardFormChangeTracking: {
    key: 'enable-ltl-wizard-form-change-tracking',
    defaultValue: false,
  },
  enableLtlProductFields: {
    key: 'enable-ltl-product-fields',
    defaultValue: false,
  },
  enableLtlShipmentKeyedExport: {
    key: 'enable-ltl-shipment-keyed-export',
    defaultValue: false,
  },
  enableExtraAutomationPlaybooks: {
    key: 'enable-extra-automation-playbooks',
    defaultValue: false,
  },
  enableSerialNumberTracking: {
    key: 'enable-serial-number-tracking',
    defaultValue: false,
  },
  enableAutomationHubReskin: {
    key: 'enable-automation-hub-reskin',
    defaultValue: false,
  },
  enableWorkflowNlp: {
    key: 'enable-workflow-nlp',
    defaultValue: false,
  },
  enableInsuranceColumn: {
    key: 'enable-insurance-column',
    defaultValue: false,
  },
  enablePickPackStation: {
    key: 'enable-pick-pack-station',
    defaultValue: false,
  },
  enablePickPackStationV2Features: {
    key: 'enable-pick-pack-station-v2-features',
    defaultValue: false,
  },
  enableFigtreeFont: {
    key: 'enable-figtree-font',
    defaultValue: false,
  },
  enableCsvFreightImport: {
    key: 'enable-csv-freight-import',
    defaultValue: false,
  },
  enableFreightExport: {
    key: 'enable-freight-export',
    defaultValue: true,
  },
  enableBundleDisplayModeEnum: {
    key: 'enable-bundle-display-mode-enum',
    defaultValue: false,
  },
  enableBulkDeleteInventoryLocations: {
    key: 'bulk-delete-inventory-locations',
    defaultValue: false,
  },
  enableShowIndividualItemsOnOrderSidebar: {
    key: 'enable-show-individual-items-on-order-sidebar',
    defaultValue: false,
  },
  enableKlaviyoIntegration: {
    key: 'enable-klaviyo-integration',
    defaultValue: false,
  },
  enableMultiPackageItemAllocation: {
    key: 'enable-multi-package-item-allocation',
    defaultValue: false,
  },
  enableHomepageTables: {
    key: 'enable-homepage-tables',
    defaultValue: false,
  },
  enableHomepageQuickActions: {
    key: 'enable-homepage-quick-actions',
    defaultValue: false,
  },
  enableHomepageCreateLabel: {
    key: 'enable-homepage-create-label',
    defaultValue: false,
  },
  enableLiteToV3FtuPreCompletion: {
    key: 'enable-lite-to-v3-ftu-pre-completion',
    defaultValue: false,
  },
  enablePackageDropdownGenericFallback: {
    key: 'enable-package-dropdown-generic-fallback',
    defaultValue: false,
  },
  enableSierraFreightHandoff: {
    key: 'enable-sierra-freight-handoff',
    defaultValue: false,
  },
  enableSierraFreightHandoffSkip: {
    key: 'enable-sierra-freight-handoff-skip',
    defaultValue: false,
  },
  enableLabelPurchaseGate: {
    key: 'enable-label-purchase-gate',
    defaultValue: false,
  },
  enableShipFromAddressValidation: {
    key: 'enable-ship-from-address-validation',
    defaultValue: false,
  },
  enableLtlShipToAddressValidation: {
    key: 'enable-ltl-ship-to-address-validation',
    defaultValue: false,
  },
  enableShopifyOrderProgressRow: {
    key: 'enable-shopify-order-progress-row',
    defaultValue: false,
  },
  enableClientCommonStepUpAuth: {
    key: 'enable-client-common-step-up-auth',
    defaultValue: false,
  },
  enableMultipackagePhase2: {
    key: 'enable-multipackage-phase-2',
    defaultValue: false,
  },
  enableDefaultRateShopperPopup: {
    key: 'enable-default-rate-shopper-popup',
    defaultValue: false,
  },
  enablePurchaseAdditionalShipments: {
    key: 'enable-purchase-additional-shipments',
    defaultValue: false,
  },
};
